<script setup>
import { useI18n } from 'vue-i18n';
import { vOnClickOutside } from '@vueuse/components';

import Button from 'dashboard/components-next/button/Button.vue';
import DropdownMenu from 'dashboard/components-next/dropdown-menu/DropdownMenu.vue';

defineProps({
  selectedTeam: {
    type: Object,
    default: null,
  },
  showTeamsDropdown: {
    type: Boolean,
    required: true,
  },
  teamsList: {
    type: Array,
    default: () => [],
  },
  hasSelectedInbox: {
    type: Boolean,
    default: false,
  },
});

const emit = defineEmits(['updateTeam', 'toggleDropdown', 'handleTeamAction']);

const { t } = useI18n();
</script>

<template>
  <div
    class="relative flex items-center flex-1 w-full gap-3 px-4 py-3 overflow-visible"
  >
    <label class="mb-0.5 text-sm font-medium text-n-slate-11 whitespace-nowrap">
      {{ t('COMPOSE_NEW_CONVERSATION.FORM.TEAM_SELECTOR.LABEL') }}
    </label>
    <div
      v-if="selectedTeam"
      class="flex items-center gap-1.5 rounded-md bg-n-alpha-2 truncate ltr:pl-3 rtl:pr-3 ltr:pr-1 rtl:pl-1 h-7 min-w-0"
    >
      <span class="text-sm truncate text-n-slate-12">
        {{ selectedTeam.name }}
      </span>
      <Button
        variant="ghost"
        icon="i-lucide-x"
        color="slate"
        size="xs"
        class="flex-shrink-0"
        @click="emit('updateTeam', null)"
      />
    </div>
    <div
      v-else
      v-on-click-outside="() => emit('toggleDropdown', false)"
      class="relative flex items-center h-7"
    >
      <Button
        :label="t('COMPOSE_NEW_CONVERSATION.FORM.TEAM_SELECTOR.BUTTON')"
        variant="link"
        size="sm"
        color="slate"
        :disabled="!hasSelectedInbox"
        class="hover:!no-underline"
        @click="emit('toggleDropdown', !showTeamsDropdown)"
      />
      <DropdownMenu
        v-if="teamsList?.length > 0 && showTeamsDropdown"
        :menu-items="teamsList"
        class="ltr:left-0 rtl:right-0 z-[100] top-8 overflow-y-auto max-h-56 w-fit max-w-sm dark:!outline-n-slate-5"
        @action="emit('handleTeamAction', $event)"
      />
    </div>
  </div>
</template>
